import {
  GET_DETAIL_CHOVAY,
  GET_DETAIL_CHOVAY_SUCCESS,
  GET_DETAIL_CHOVAY_FAILURE,
  GET_LAIDENNGAY_CHOVAY,
  GET_LAIDENNGAY_CHOVAY_SUCCESS,
  GET_LAIDENNGAY_CHOVAY_FAILURE,
  GET_LANDONGLAI_CHOVAY_FAILURE,
  GET_LANDONGLAI_CHOVAY,
  GET_LANDONGLAI_CHOVAY_SUCCESS,
  GET_LICHSUGIAHAN_CHOVAY_FAILURE,
  GET_LICHSUGIAHAN_CHOVAY,
  GET_LICHSUGIAHAN_CHOVAY_SUCCESS,
  POST_GIAHAN_CHOVAY_FAILURE,
  POST_GIAHAN_CHOVAY,
  POST_GIAHAN_CHOVAY_SUCCESS,
  GET_LICHSUTRABOTGOC_CHOVAY_FAILURE,
  GET_LICHSUTRABOTGOC_CHOVAY,
  GET_LICHSUTRABOTGOC_CHOVAY_SUCCESS,
  POST_TRABOTGOC_CHOVAY_FAILURE,
  POST_TRABOTGOC_CHOVAY,
  POST_TRABOTGOC_CHOVAY_SUCCESS,
  GET_LICHSUVAYTHEM_CHOVAY_FAILURE,
  GET_LICHSUVAYTHEM_CHOVAY,
  GET_LICHSUVAYTHEM_CHOVAY_SUCCESS,
  POST_VAYTHEM_CHOVAY_FAILURE,
  POST_VAYTHEM_CHOVAY,
  POST_VAYTHEM_CHOVAY_SUCCESS,
  POST_THAYDOILAISUAT_CHOVAY_FAILURE,
  POST_THAYDOILAISUAT_CHOVAY,
  POST_THAYDOILAISUAT_CHOVAY_SUCCESS,
  POST_THAYDOIKYTHANHTOAN_CHOVAY_FAILURE,
  POST_THAYDOIKYTHANHTOAN_CHOVAY,
  POST_THAYDOIKYTHANHTOAN_CHOVAY_SUCCESS,
  POST_TATTOAN_CHOVAY_FAILURE,
  POST_TATTOAN_CHOVAY,
  POST_TATTOAN_CHOVAY_SUCCESS,
  POST_TATTOAN_CHODUYET_CHOVAY,
  POST_TATTOAN_CHODUYET_CHOVAY_SUCCESS,
  POST_TATTOAN_CHODUYET_CHOVAY_FAILURE,
  GET_TATTOAN_CHOVAY_FAILURE,
  GET_TATTOAN_CHOVAY,
  GET_TATTOAN_CHOVAY_SUCCESS,
  DELETE_VAYTHEM_CHOVAY,
  DELETE_VAYTHEM_CHOVAY_SUCCESS,
  DELETE_VAYTHEM_CHOVAY_FAILURE,
  DELETE_TRABOTGOC_CHOVAY,
  DELETE_TRABOTGOC_CHOVAY_SUCCESS,
  DELETE_TRABOTGOC_CHOVAY_FAILURE,
  GET_LAIDENKY_CHOVAY,
} from "actions/QuanLyChoVay/actionTypes";

const initialState = {
  getDetailChoVayLoading: false,
  posts: [],
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
  totalRow: 0,
  getLanDongLaiChoVayLoading: false,
  objListDonglai: {
    List: [],
    totalRow: 0,
    TongTienGoc: 0,
    TongCanThanhToan: 0,
    TongThanhToan: 0,
    TongTienLai: 0,
    TongPhiKhac: 0,
    TongPhiKho: 0,
    TongPhiKhacHangKy: 0,
  },
  getLaiDenNgayChoVayLoading: false,
  LaiDenNgay: 0,
  PhiKho: 0,
  postGiaHanChoVayLoading: false,
  getLichSuGiaHanChoVayLoading: false,
  LichSuGiaHan: {
    ListGiaHan: [],
    TotalRowGiaHan: 0,
  },
  LichSuDoiKyThanhToan: {
    ListDoiKyLai: [],
    TotalRowThayDoiKyThanhToan: 0,
  },
  LichSuTraBotGoc: {
    ListTraBotGoc: [],
    TotalRowTraBotGoc: 0,
  },
  getLichSuTraBotGocChoVayLoading: false,
  getLichSuVayThemChoVayLoading: false,
  LichSuVayThem: {
    ListVayThem: [],
    TotalRowVayThem: 0,
  },
  traBotGocChoVayLoading: false,
  postVayThemChoVayLoading: false,
  tatToanChoVayLoading: false,
  deleteVayThemChoVayLoading: false,
  infoTatToan: {
    ChoVayId: 0,
    Code: "",
    Type: 0,
    Note: "",
    NgayTra: "",
    Sotienvay: 0.0,
    NgayVay: "",
    KieuVay: "",
    LaiSuat: "",
    KieuLaiSuat: 1,
    PhiPhatThanhToanSom: 0.0,
    TongTienPhaiTra: 0.0,
    SoTienDaTra: 0.0,
    SoTienConPhaiTra: 0.0,
    SoNgayTraLai: "Số ngày trả lãi: 122",
    ChietKhau: 0.0,
    PhiKho: 0.0,
    NotePaidTatToan: null,
    TienTatToan: 0.0,
    PhiPhatDongLai: 0,
    PhiPhatTatToan: 0,
    PhiDongLaiCham: 0.0,
  },
  errorTatToan: false,
};

const getDetailChoVay = (state, action) => ({
  ...state,
  getDetailChoVayLoading: true,
});

const getDetailChoVaySuccess = (state, action) => {
  return {
    ...state,
    getDetailChoVayLoading: false,
    objList: action.payload,
  };
};

const getDetailChoVayFailed = (state, action) => ({
  ...state,
  getDetailChoVayLoading: false,
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
});

// lan dong lai
const getLanDongLaiChoVay = (state, action) => ({
  ...state,
  getLanDongLaiChoVayLoading: true,
});

const getLanDongLaiChoVaySuccess = (state, action) => {
  return {
    ...state,
    getLanDongLaiChoVayLoading: false,
    objListDonglai: action.payload,
  };
};

const getLanDongLaiChoVayFailed = (state, action) => ({
  ...state,
  getLanDongLaiChoVayLoading: false,
  objListDonglai: {
    List: [],
    totalRow: 0,
    TongTienGoc: 0,
    TongCanThanhToan: 0,
    TongThanhToan: 0,
    TongTienLai: 0,
    TongPhiKhac: 0,
    TongPhiKho: 0,
    TongPhiKhacHangKy: 0,
    TotalPhiDongLaiCham: 0,
  },
});

// Lai Den Ngay
const getLaiDenNgayChoVay = (state, action) => ({
  ...state,
  getLaiDenNgayChoVayLoading: true,
});
const getLaiDenKyChoVay = (state, action) => ({
  ...state,
  getLaiDenNgayChoVayLoading: true,
});

const getLaiDenNgayChoVaySuccess = (state, action) => {
  return {
    ...state,
    getLaiDenNgayChoVayLoading: false,
    LaiDenNgay: action.payload.laiDenNgay,
    PhiKho: action.payload.phiKho,
  };
};
const getLaiDenNgayChoVayFailed = (state, action) => ({
  ...state,
  getLaiDenNgayChoVayLoading: false,
  LaiDenNgay: 0,
  PhiKho: 0,
});

export const getLichSuGiaHanChoVay = (state, action) => ({
  ...state,
  getLichSuGiaHanChoVayLoading: true,
  LaiDenNgay: 0,
  PhiKho: 0,
});

export const getLichSuGiaHanChoVaySuccess = (state, action) => {
  return {
    ...state,
    getLichSuGiaHanChoVayLoading: false,
    LichSuGiaHan: action.payload,
  };
};

export const getLichSuGiaHanChoVayFailure = (state, action) => ({
  ...state,
  getLichSuGiaHanChoVayLoading: false,
  LichSuGiaHan: {
    ListGiaHan: [],
    TotalRowGiaHan: 0,
  },
});
export const getLichSuDoiKyThanhToanChoVay = (state, action) => ({
  ...state,
  getLichSuDoiKyThanhToanChoVayLoading: true,
  LaiDenNgay: 0,
  PhiKho: 0,
});

export const getLichSuDoiKyThanhToanChoVaySuccess = (state, action) => {
  return {
    ...state,
    getLichSuDoiKyThanhToanChoVayLoading: false,
    LichSuDoiKyThanhToan: action.payload,
  };
};

export const getLichSuDoiKyThanhToanChoVayFailure = (state, action) => ({
  ...state,
  getLichSuDoiKyThanhToanChoVayLoading: false,
  LichSuDoiKyThanhToan: {
    ListDoiKyLai: [],
    TotalRowDoiKyLai: 0,
  },
});
const postGiaHanChoVay = (state, action) => ({
  ...state,
  postGiaHanChoVayLoading: true,
});
const postGiaHanChoVaySuccess = (state, action) => {
  return {
    ...state,
    postGiaHanChoVayLoading: false,
  };
};

const postGiaHanChoVayFailure = (state, action) => ({
  ...state,
  postGiaHanChoVayLoading: false,
});

export const getLichSuTraBotGocChoVay = (state, action) => ({
  ...state,
  traBotGocChoVayLoading: true,
});

export const getLichSuTraBotGocChoVaySuccess = (state, action) => {
  return {
    ...state,
    traBotGocChoVayLoading: false,
    LichSuTraBotGoc: action.payload,
  };
};

export const getLichSuTraBotGocChoVayFailure = (state, action) => ({
  ...state,
  traBotGocChoVayLoading: false,
  LichSuTraBotGoc: {
    ListTraBotGoc: [],
    TotalRowTraBotGoc: 0,
  },
});

const postTraBotGocChoVay = (state, action) => ({
  ...state,
  traBotGocChoVayLoading: true,
});
const postTraBotGocChoVaySuccess = (state, action) => {
  return {
    ...state,
    traBotGocChoVayLoading: false,
  };
};

const postTraBotGocChoVayFailure = (state, action) => ({
  ...state,
  traBotGocChoVayLoading: false,
});

export const getLichSuVayThemChoVay = (state, action) => ({
  ...state,
  getLichSuVayThemChoVayLoading: true,
  LaiDenNgay: 0,
});

export const getLichSuVayThemChoVaySuccess = (state, action) => {
  return {
    ...state,
    getLichSuVayThemChoVayLoading: false,
    LichSuVayThem: action.payload,
  };
};

export const getLichSuVayThemChoVayFailure = (state, action) => ({
  ...state,
  getLichSuVayThemChoVayLoading: false,
  LichSuVayThem: {
    ListVayThem: [],
    TotalRowVayThem: 0,
  },
});

const postVayThemChoVay = (state, action) => ({
  ...state,
  postVayThemChoVayLoading: true,
});
const postVayThemChoVaySuccess = (state, action) => {
  return {
    ...state,
    postVayThemChoVayLoading: false,
  };
};

const postVayThemChoVayFailure = (state, action) => ({
  ...state,
  postVayThemChoVayLoading: false,
});

const postThayDoiLaiSuatChoVay = (state, action) => ({
  ...state,
  postThayDoiLaiSuatChoVayLoading: true,
});

const postThayDoiLaiSuatChoVayFailure = (state, action) => ({
  ...state,
  postThayDoiLaiSuatChoVayLoading: false,
});

const postThayDoiLaiSuatChoVaySuccess = (state, action) => ({
  ...state,
  postThayDoiLaiSuatChoVayLoading: false,
});

const postThayDoiKyThanhToanChoVay = (state, action) => ({
  ...state,
  postThayDoiLaiSuatChoVayLoading: true,
});

const postThayDoiKyThanhToanChoVayFailure = (state, action) => ({
  ...state,
  postThayDoiLaiSuatChoVayLoading: false,
});

const postThayDoiKyThanhToanChoVaySuccess = (state, action) => ({
  ...state,
  postThayDoiLaiSuatChoVayLoading: false,
});

const postTatToanChoVay = (state, action) => ({
  ...state,
  tatToanChoVayLoading: true,
});
const postTatToanChoVaySuccess = (state, action) => {
  return {
    ...state,
    tatToanChoVayLoading: false,
    errorTatToan: false,
  };
};

const postTatToanChoVayFailure = (state, action) => ({
  ...state,
  tatToanChoVayLoading: false,
  errorTatToan: true,
});
const postTatToanChoDuyetChoVay = (state, action) => ({
  ...state,
  tatToanChoVayLoading: true,
});
const postTatToanChoDuyetChoVaySuccess = (state, action) => {
  return {
    ...state,
    tatToanChoVayLoading: false,
    errorTatToan: false,
  };
};

const postTatToanChoDuyetChoVayFailure = (state, action) => ({
  ...state,
  tatToanChoVayLoading: false,
  errorTatToan: true,
});
const getTatToanChoVay = (state, action) => ({
  ...state,
  tatToanChoVayLoading: true,
});
const getTatToanChoVaySuccess = (state, action) => {
  return {
    ...state,
    tatToanChoVayLoading: false,
    infoTatToan: action.payload,
  };
};

const getTatToanChoVayFailure = (state, action) => ({
  ...state,
  tatToanChoVayLoading: false,
  infoTatToan: {
    ChoVayId: 0,
    Code: "",
    Type: 0,
    Note: "",
    NgayTra: "",
    Sotienvay: 0.0,
    NgayVay: "",
    KieuVay: "",
    LaiSuat: "",
    KieuLaiSuat: 1,
    PhiPhatThanhToanSom: 0.0,
    TongTienPhaiTra: 0.0,
    SoTienDaTra: 0.0,
    SoTienConPhaiTra: 0.0,
    SoNgayTraLai: "",
    ChietKhau: 0.0,
    PhiKho: 0.0,
    NotePaidTatToan: null,
    TienTatToan: 0.0,
    PhiPhatDongLai: 0,
    PhiPhatTatToan: 0,
    PhiDongLaiCham: 0,
  },
});

const deleteVayThemChoVay = (state, action) => ({
  ...state,
  deleteVayThemChoVayLoading: true,
});
const deleteVayThemChoVaySuccess = (state, action) => {
  return {
    ...state,
    deleteVayThemChoVayLoading: false,
  };
};

const deleteVayThemChoVayFailure = (state, action) => ({
  ...state,
  deleteVayThemChoVayLoading: false,
});

const deleteTraBotGocChoVay = (state, action) => ({
  ...state,
  traBotGocChoVayLoading: true,
});
const deleteTraBotGocChoVaySuccess = (state, action) => {
  return {
    ...state,
    traBotGocChoVayLoading: false,
  };
};

const deleteTraBotGocChoVayFailure = (state, action) => ({
  ...state,
  traBotGocChoVayLoading: false,
});
const quanLyChoVayReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DETAIL_CHOVAY:
      return getDetailChoVay(state, action);
    case GET_DETAIL_CHOVAY_SUCCESS:
      return getDetailChoVaySuccess(state, action);
    case GET_DETAIL_CHOVAY_FAILURE:
      return getDetailChoVayFailed(state, action);
    case GET_LANDONGLAI_CHOVAY:
      return getLanDongLaiChoVay(state, action);
    case GET_LANDONGLAI_CHOVAY_SUCCESS:
      return getLanDongLaiChoVaySuccess(state, action);
    case GET_LANDONGLAI_CHOVAY_FAILURE:
      return getLanDongLaiChoVayFailed(state, action);
    case GET_LAIDENNGAY_CHOVAY:
      return getLaiDenNgayChoVay(state, action);
    case GET_LAIDENKY_CHOVAY:
      return getLaiDenKyChoVay(state, action);
    case GET_LAIDENNGAY_CHOVAY_SUCCESS:
      return getLaiDenNgayChoVaySuccess(state, action);
    case GET_LAIDENNGAY_CHOVAY_FAILURE:
      return getLaiDenNgayChoVayFailed(state, action);
    case GET_LICHSUGIAHAN_CHOVAY:
      return getLichSuGiaHanChoVay(state, action);
    case GET_LICHSUGIAHAN_CHOVAY_SUCCESS:
      return getLichSuGiaHanChoVaySuccess(state, action);
    case GET_LICHSUGIAHAN_CHOVAY_FAILURE:
      return getLichSuGiaHanChoVayFailure(state, action);
    case POST_GIAHAN_CHOVAY:
      return postGiaHanChoVay(state, action);
    case POST_GIAHAN_CHOVAY_SUCCESS:
      return postGiaHanChoVaySuccess(state, action);
    case POST_GIAHAN_CHOVAY_FAILURE:
      return postGiaHanChoVayFailure(state, action);
    case GET_LICHSUTRABOTGOC_CHOVAY:
      return getLichSuTraBotGocChoVay(state, action);
    case GET_LICHSUTRABOTGOC_CHOVAY_SUCCESS:
      return getLichSuTraBotGocChoVaySuccess(state, action);
    case GET_LICHSUTRABOTGOC_CHOVAY_FAILURE:
      return getLichSuTraBotGocChoVayFailure(state, action);
    case POST_TRABOTGOC_CHOVAY:
      return postTraBotGocChoVay(state, action);
    case POST_TRABOTGOC_CHOVAY_SUCCESS:
      return postTraBotGocChoVaySuccess(state, action);
    case POST_TRABOTGOC_CHOVAY_FAILURE:
      return postTraBotGocChoVayFailure(state, action);
    case GET_LICHSUVAYTHEM_CHOVAY:
      return getLichSuVayThemChoVay(state, action);
    case GET_LICHSUVAYTHEM_CHOVAY_SUCCESS:
      return getLichSuVayThemChoVaySuccess(state, action);
    case GET_LICHSUVAYTHEM_CHOVAY_FAILURE:
      return getLichSuVayThemChoVayFailure(state, action);
    case POST_VAYTHEM_CHOVAY:
      return postVayThemChoVay(state, action);
    case POST_VAYTHEM_CHOVAY_SUCCESS:
      return postVayThemChoVaySuccess(state, action);
    case POST_VAYTHEM_CHOVAY_FAILURE:
      return postVayThemChoVayFailure(state, action);
    case POST_THAYDOILAISUAT_CHOVAY:
      return postThayDoiLaiSuatChoVay(state, action);
    case POST_THAYDOILAISUAT_CHOVAY_SUCCESS:
      return postThayDoiLaiSuatChoVaySuccess(state, action);
    case POST_THAYDOILAISUAT_CHOVAY_FAILURE:
      return postThayDoiLaiSuatChoVayFailure(state, action); 

    case POST_THAYDOIKYTHANHTOAN_CHOVAY:
      return postThayDoiKyThanhToanChoVay(state, action);
    case POST_THAYDOIKYTHANHTOAN_CHOVAY_SUCCESS:
      return postThayDoiKyThanhToanChoVaySuccess(state, action);
    case POST_THAYDOIKYTHANHTOAN_CHOVAY_FAILURE:
      return postThayDoiKyThanhToanChoVayFailure(state, action);

    case POST_TATTOAN_CHOVAY:
      return postTatToanChoVay(state, action);
    case POST_TATTOAN_CHOVAY_SUCCESS:
      return postTatToanChoVaySuccess(state, action);
    case POST_TATTOAN_CHOVAY_FAILURE:
      return postTatToanChoVayFailure(state, action);
    case POST_TATTOAN_CHODUYET_CHOVAY:
      return postTatToanChoDuyetChoVay(state, action);
    case POST_TATTOAN_CHODUYET_CHOVAY_SUCCESS:
      return postTatToanChoDuyetChoVaySuccess(state, action);
    case POST_TATTOAN_CHODUYET_CHOVAY_FAILURE:
      return postTatToanChoDuyetChoVayFailure(state, action);
    case DELETE_VAYTHEM_CHOVAY:
      return deleteVayThemChoVay(state, action);
    case DELETE_VAYTHEM_CHOVAY_SUCCESS:
      return deleteVayThemChoVaySuccess(state, action);
    case DELETE_VAYTHEM_CHOVAY_FAILURE:
      return deleteVayThemChoVayFailure(state, action);
    case DELETE_TRABOTGOC_CHOVAY:
      return deleteTraBotGocChoVay(state, action);
    case DELETE_TRABOTGOC_CHOVAY_SUCCESS:
      return deleteTraBotGocChoVaySuccess(state, action);
    case DELETE_TRABOTGOC_CHOVAY_FAILURE:
      return deleteTraBotGocChoVayFailure(state, action);
    case GET_TATTOAN_CHOVAY:
      return getTatToanChoVay(state, action);
    case GET_TATTOAN_CHOVAY_SUCCESS:
      return getTatToanChoVaySuccess(state, action);
    case GET_TATTOAN_CHOVAY_FAILURE:
      return getTatToanChoVayFailure(state, action);
    default:
      return state;
  }
};

export default quanLyChoVayReducer;
